// extracted by mini-css-extract-plugin
module.exports = {"root":"oqneL8db"};